import { render, staticRenderFns } from "./InterBranchTransaction.vue?vue&type=template&id=c7b16174&"
import script from "./InterBranchTransaction.vue?vue&type=script&lang=js&"
export * from "./InterBranchTransaction.vue?vue&type=script&lang=js&"
import style0 from "./InterBranchTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports